import sassVariables from '../../styles/variables.module.scss';

export const desktopWidthBreakPoint = Number(sassVariables['desktopWidth'].replace('px', ''));
